<script>
// This used to render its own copy of the loader. That meant the boot loader
// in index.html and this one were two separate elements with two separate
// animations, each starting when its own element was created — so at the
// handoff the ring visibly jumped to a different phase and the whole thing
// read as the logo rendering twice.
//
// There is now a single persistent overlay in public/index.html. This
// component renders nothing and simply holds that overlay open for as long as
// it is mounted, so every loading state in the app is one continuous
// animation. Usage is unchanged: <Loader v-if="..." />
export default {
    name: "Loader",
    render: () => null,
    mounted() {
        if (window.__appLoader) window.__appLoader.acquire();
    },
    unmounted() {
        if (window.__appLoader) window.__appLoader.release();
    },
};
</script>
